import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from "redux";
import {PageLoader} from "../../../../components/Loader";
import _ from "lodash";
import {fetchUserStatus, resetUserStatus} from "../../../../../creators/user.status";
import CardStatus from "../../../../components/timeline/components/CardStatus";
import ErrorNotFound from "../../../ErrorNotFound";
import {config} from "../../../../../config";
import Helmet from "react-helmet";


class ProfileStatus extends React.Component {

    constructor(props) {
        super(props);
        let statusId = _.get(this.props, 'match.params.statusId');
        let userId = _.get(this.props, 'user._id');
        if(userId && statusId){
            this.props.fetchUserStatus(userId, statusId);
        }

    }

    componentWillUnmount() {
        this.props.resetUserStatus();
    }

    render() {
        if(this.props.userStatusError.statusCode === 404){
            return <ErrorNotFound />
        }

        return !this.props.userStatusInitialized ? (
            <div className={"card "}>
                <PageLoader/>
            </div>
        ) : (
            <div className="card">
                <Helmet>
                    <title>{config.preTitle}Statut publié par {_.get(this.props.userStatus,"owner.username") || ""}{config.postTitle}</title>
                    <meta name="robots" content="noindex" />
                </Helmet>
                <h2>Publication sur le mur</h2>
                <CardStatus parentId={this.props.userStatus} createdAt={this.props.userStatus.createdAt}/>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        userStatus: state.userStatus.data,
        userStatusLoading: state.userStatus.loading,
        userStatusInitialized: state.userStatus.initialized,
        userStatusError: state.userStatus.error,
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchUserStatus,
    resetUserStatus
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ProfileStatus);
